import type { UseFormSetError } from 'react-hook-form';

import type { ErrorObjectArray } from '@liscio/api';

import type { CreateContactFormValues } from './createContactValidationSchema';

const FIELD_ERROR_PATTERNS: Array<{
  field: keyof CreateContactFormValues;
  pattern: RegExp;
}> = [
  { field: 'first_name', pattern: /\b(first name|first_name)\b/i },
  { field: 'last_name', pattern: /\b(last name|last_name)\b/i },
  { field: 'primary_email', pattern: /\b(email|primary_email)\b/i },
  { field: 'job_title', pattern: /\b(job title|job_title)\b/i },
  { field: 'phone', pattern: /\b(phone|phone_number)\b/i },
];

/**
 * Maps V5 `422` error payloads onto form fields when the message mentions a field.
 */
export function applyCreateContactApiErrors(
  error: ErrorObjectArray,
  setError: UseFormSetError<CreateContactFormValues>
): string {
  const messages =
    error.errors?.map((entry) => entry.message).filter(Boolean) ?? [];

  if (messages.length === 0) {
    return 'Unable to create contact. Please try again.';
  }

  messages.forEach((message) => {
    const match = FIELD_ERROR_PATTERNS.find(({ pattern }) =>
      pattern.test(message ?? '')
    );

    if (match) {
      setError(match.field, { type: 'server', message: message ?? '' });
    }
  });

  return messages[0] ?? 'Unable to create contact. Please try again.';
}
